import { createContext } from 'react';

export const DrawContext = createContext();
